/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import CustomText from '../../components/customText/CustomText';
import Friends from '../../components/friends';
import theme from '../../constants/theme.style.js';
import NewMessageHeader from '../../components/newMessageHeader';

const loginTurtle = require('../../assets/Turtles/main-turtle.png');

const styles = StyleSheet.create({
  icon: {
    width: theme.ICON_WIDTH,
    height: theme.ICON_WIDTH,
  },
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  detailContainer: {
    flex: 1,
    backgroundColor: theme.WHITE_COLOR,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    paddingRight: theme.CONTAINER_MARGIN,
    paddingLeft: theme.CONTAINER_MARGIN,
  },
  subHeader: {
    color: theme.GREEN_DARKER_COLOR,
    marginTop: theme.CONTAINER_MARGIN * 1.5,
    marginBottom: theme.CONTAINER_MARGIN,
    fontSize: theme.FONT_SIZE_HEADLINE,
    fontWeight: 'bold',
    alignItems: 'center',
    paddingLeft: 20,
  },
  noMessagesContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.WHITE_COLOR,
    width: '100%',
    height: '100%',
    padding: theme.CONTAINER_MARGIN,
  },
  noMessagesText: {
    marginTop: theme.CONTAINER_MARGIN,
    textAlign: 'center',
  },
  turtleTop: {
    width: '30%',
    height: 120,
  },
});

export default class NewMessageFriendsSelection extends React.Component {
  render() {
    const { navigation, friends } = this.props;
    return (
      <View style={styles.container}>
        <NewMessageHeader
          navigation={navigation}
          nextScreen="NewMessage"
          previousScreen="" // change to actual previous Screen !!!!!!
          allowNext={friends.length > 0}
        />
        {friends.length > 0 && (
          <View style={styles.detailContainer}>
            <CustomText style={styles.subHeader}>Choose A Friend:</CustomText>
            <Friends selectFriend />
          </View>
        )}
        {friends.length === 0 && (
          <View style={styles.noMessagesContainer}>
            <Image
              style={styles.turtleTop}
              source={loginTurtle}
              resizeMode="contain"
              testID="turtle"
            />
            <CustomText style={styles.noMessagesText} testID="noFriendsText">
              No friends yet.
              {'\n'}
              Start your journey by adding friends and writing letters to them.
            </CustomText>
          </View>
        )}
      </View>
    );
  }
}
